<div class="form" *ngIf="formGroup && formTemplate">
  <ng-container
    *ngTemplateOutlet="formTemplate; context: {form: formGroup, value: formValue}">
  </ng-container>
  <button type="submit" mat-raised-button (click)="sendForm()" class="primary" style="margin-top: 15px;" [disabled]="!formGroup.valid">Guardar</button>
</div>

